import { CommonActionType } from '../../common/common-actions';
import { CommonLabParentResourceActionType } from '../../lab-parent-resource/lab-parent-resource-actions';
import { CommonLabPlanActionType } from '../../lab-plan/lab-plan-actions';
import { CommonLabActionType } from '../../lab/lab-actions';
export const UsageActionType = {
    ...CommonActionType,
    ...CommonLabPlanActionType,
    ...CommonLabParentResourceActionType,
    ...CommonLabActionType,
    LIST_USAGE_DATA: 'LIST_USAGE_DATA',
    LIST_REGION_USAGE_DATA_SUCCESS: 'LIST_REGION_USAGE_DATA_SUCCESS',
    LIST_USAGE_DATA_ERROR: 'LIST_USAGE_DATA_ERROR',
    LIST_USAGE_DATA_CANCELLED: 'LIST_USAGE_DATA_CANCELLED',
    LIST_USAGE_DATA_SUCCESS: 'LIST_USAGE_DATA_SUCCESS',
};
